export default class AddToOrder extends HTMLSelectElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
    }

    events() {
        $(this).on('change', function(e) {
            $.ajax({
                url: '/change-order-reference',
                method: 'POST',
                data: {order_id:$(this).val(),cart_id:$(this).data('cart_id')},
                success: function (data) {
                    //On refresh la page pour hériter ou non de la commande choisie
                    window.location.reload();
                }
            });

        });
    }

}
